/**
 * Standard API response models
 */

/**
 * Generic API response wrapper
 */
export interface ApiResponse<T> {
  success: boolean;
  data?: T;
  message?: string;
  statusCode?: number;
}

/**
 * API error response
 *
 * @deprecated Use {@link ApiErrorResponse} from 'cms-post-lib' instead.
 * This interface will be removed once all consumers are migrated.
 */
export interface ApiError {
  success: false;
  message: string;
  statusCode: number;
  errors?: Record<string, string[]>;
}

/**
 * Paginated API response
 */
export interface PaginatedResponse<T> {
  success: boolean;
  count: number;
  data: T[];
  pagination: PaginationMeta;
  message?: string;
}

/**
 * Pagination metadata
 */
export interface PaginationMeta {
  page: number;
  limit: number;
  total: number;
  pages: number;
  hasNext?: boolean;
  hasPrev?: boolean;
}

/**
 * Query parameters for list/search operations
 */
export interface QueryParams {
  [key: string]: string | number | boolean | string[] | undefined;
}
